import {
  Button,
  Container,
  Flex,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import React, { ComponentType } from 'react';
import { SignupStepFooter } from 'src/components/common/features/Signup/components/SignupStepFooter/SignupStepFooter';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { useSignupStatus } from 'src/components/selfService/features/Signup/context/SignupStatusProvider/SignupStatusProvider';
import {
  getValidationStepFooterConfig,
  getValidationStepState,
  ValidationStepState,
  ValidationStepStateComponentProps,
} from 'src/components/selfService/features/Signup/steps/ValidationStep/ValidationStep.utils';
import { PendingState } from 'src/components/selfService/features/Signup/steps/ValidationStep/states/PendingState';
import { InReviewState } from 'src/components/selfService/features/Signup/steps/ValidationStep/states/InReviewState';
import { RejectedState } from 'src/components/selfService/features/Signup/steps/ValidationStep/states/RejectedState';
import { ApprovedWithNetTermsState } from 'src/components/selfService/features/Signup/steps/ValidationStep/states/ApprovedWithNetTermsState';
import { ApprovedWithoutNetTermsState } from 'src/components/selfService/features/Signup/steps/ValidationStep/states/ApprovedWithoutNetTermsState';
import { BalanceOnboardingButton } from 'src/components/selfService/features/Signup/steps/ValidationStep/components/BalanceOnboardingButton';

const STATE_COMPONENTS: Record<
  ValidationStepState,
  ComponentType<ValidationStepStateComponentProps>
> = {
  [ValidationStepState.PENDING]: PendingState,
  [ValidationStepState.IN_REVIEW]: InReviewState,
  [ValidationStepState.REJECTED]: RejectedState,
  [ValidationStepState.APPROVED_WITH_NET_TERMS]: ApprovedWithNetTermsState,
  [ValidationStepState.APPROVED_WITHOUT_NET_TERMS]:
    ApprovedWithoutNetTermsState,
};

export function ValidationStep(): JSX.Element {
  const { isPhone } = useScreenSizes();
  const { balance, goToNextStep, goToPreviousStep, sendBackButtonAnalytics } =
    useSignupStatus();

  const state = getValidationStepState({
    validationStatus: balance.validationStatus,
    creditLimit: balance.creditLimit,
  });
  const { shouldOpenOnboardingUrl, primaryText, isPrimaryDisabled } =
    getValidationStepFooterConfig(state);

  const StateComponent = STATE_COMPONENTS[state];

  function onBackButtonClick() {
    sendBackButtonAnalytics();
    goToPreviousStep();
  }

  const alignItems = isPhone ? 'flex-start' : 'center';

  return (
    <>
      <Container variant="sm">
        <Flex flexDirection="column" alignItems={alignItems}>
          <StateComponent
            onboardingUrl={balance.onboardingUrl}
            creditLimit={balance.creditLimit}
          />
        </Flex>
      </Container>
      <SignupStepFooter>
        <Flex justifyContent="space-between">
          <Stack
            x={isPhone ? 'x-sm' : 'none'}
            width={isPhone ? '100%' : 'auto'}
          >
            <Button
              variant="secondary"
              buttonSize="medium"
              block={isPhone}
              onClick={onBackButtonClick}
            >
              Back
            </Button>
          </Stack>
          {shouldOpenOnboardingUrl ? (
            <BalanceOnboardingButton
              block={isPhone}
              text={primaryText}
              href={balance.onboardingUrl}
              disabled={isPrimaryDisabled}
            />
          ) : (
            <Button
              variant="primary"
              buttonSize="medium"
              block={isPhone}
              disabled={isPrimaryDisabled}
              onClick={goToNextStep}
            >
              {primaryText}
            </Button>
          )}
        </Flex>
      </SignupStepFooter>
    </>
  );
}
